import { Injectable } from '@angular/core';
import { GridConfig } from '../utils/models/grid-config.model';
import { TENANT_GRID_CONFIG_DEFAULT } from '../utils/constants/tenant.const';

@Injectable({
  providedIn: 'root',
})
export class GridConfigApi {
  getGridConfig(
    gridName: string,
    defaultConfig: GridConfig = TENANT_GRID_CONFIG_DEFAULT
  ): GridConfig {
    const gridConfig = localStorage.getItem(gridName);
    return gridConfig ? JSON.parse(gridConfig) : defaultConfig;
  }

  setGridConfig(gridName: string, gridConfig: GridConfig): GridConfig {
    localStorage.setItem(gridName, JSON.stringify(gridConfig));
    return this.getGridConfig(gridName);
  }
}
